import { StringTMap } from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { AxiosHeaders, AxiosRequestConfig, GenericAbortSignal } from 'axios';

import { createUrl } from '../createUrl';

export type ClientData = {
  url: string;
  method: AxiosRequestConfig['method'];
  params?: Record<string, unknown>;
  headers?: Partial<AxiosHeaders>;
  data?: unknown;
  signal?: GenericAbortSignal;
};

export type FetchOptions = AxiosRequestConfig & {
  operationName?: string;
  servicesEndpoint?: string;
  logger?: {
    debug(message: string, extraContextual?: StringTMap<number | string | boolean | unknown>): unknown;
  };
};

export type DefaultErrorType<ErrorData> = ErrorData;
export type DefaultBodyType<BodyData> = BodyData & { headers?: Record<string, string> };

export const queryFn = async <T>(
  clientData: ClientData,
  options: FetchOptions,
  servicesEndpoint: string
): Promise<T> => {
  const { method, params, data, url, signal } = clientData;
  const fullUrl = createUrl(servicesEndpoint, { client: url.startsWith('/') ? url.slice(1) : url });

  const axiosConfig: AxiosRequestConfig = {
    data,
    params,
    method,
    url: fullUrl,
    ...(signal ? { signal } : {}),
    withCredentials: true,
    ...options,
  };

  const result = await axiosClient.request<T>(axiosConfig);
  return result.data;
};
